import React, { useEffect } from "react";
import * as s from "./Login.styles";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../../components/shared/inputs/FormikControl";
import { useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../store/actions/index";

// images
import logo from "../../../assets/images/logo.png";

const Login = () => {
  const history = useHistory();
  // const isAuthenticated = useSelector((state) => state.auth.role);

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     history.push("/");
  //   }
  // }, [isAuthenticated, history]);

  const dispatch = useDispatch();

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email format").required("Required"),
    password: Yup.string().required("Required"),
  });

  const onSubmit = (values) => {
    // console.log("Form data", values);
    dispatch(actions.login(values, () => history.push("/")));
  };

  const togglePassword = () => {
    const togglePassword = document.querySelector("#togglePassword");
    const password = document.querySelector("#password");

    // toggle the type attribute
    const type =
      password.getAttribute("type") === "password" ? "text" : "password";
    password.setAttribute("type", type);
    // toggle the eye slash icon
    togglePassword.classList.toggle("fa-eye-slash");
  };

  return (
    <s.Container>
      <s.LoginContainer>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {(formik) => {
            return (
              <Form>
                <s.LogoContainer>
                  <s.LogoImage src={logo} />
                </s.LogoContainer>
                <s.InputContainer>
                  <FormikControl
                    control="input"
                    type="email"
                    name="email"
                    placeholder="Email"
                  />
                </s.InputContainer>
                <s.InputContainer>
                  <FormikControl
                    control="input"
                    type="password"
                    name="password"
                    placeholder="Password"
                  />
                  <s.Eye
                    className="far fa-eye"
                    onClick={togglePassword}
                    id="togglePassword"
                  ></s.Eye>
                </s.InputContainer>

                <s.Button type="submit" disabled={!formik.isValid}>
                  Login
                </s.Button>
              </Form>
            );
          }}
        </Formik>
        <s.ForgetPassword>Forgot password?</s.ForgetPassword>
      </s.LoginContainer>
    </s.Container>
  );
};

export default Login;
